import React, { useState, Component } from 'react';
import Button from '../Atoms/Button';



function CategoryButtons(props) {
  
    
    

    return <nav label="Category Links" className={`flex wrap ${props.fullWidth ? 'w-100 h-10 tablet-h-25' : 'bold w-10 tablet-w-20 phone-w-25'}`}>
        <Button aria-label="KURATERING" content="KURATERING" width="10" height="5" cx="flex bb flex-basis-100 justify-content-center ta-center items-center large-h-2" rotated={false} link="/filter/kuratering" hasIcon={true} icon="🎤"/>
        <Button aria-label="VÆRKER" content="VÆRKER" width="10" height="5" cx="flex bb  flex-basis-100 justify-content-center ta-center items-center large-h-2" rotated={false} link="/filter/vaerker" hasIcon={true} icon="⚙️"/>
      </nav>
    
  
}

export default CategoryButtons;